<h1 mat-dialog-title>Afbeelding tonen</h1>

<mat-dialog-content>
  <div class="flex flex-col gap-4">
    <div class="space-y-2">
      <label class="block font-medium text-sm select-none">Afbeelding</label>

      @if (selectedMedia(); as media) {
        <div class="image-preview-container">
          <app-avatar
            class="image-preview"
            [src]="imagePreviewUrl()"
            [alt]="media.label"
          >
            <div class="image-preview-fallback">
              <mat-icon>image</mat-icon>
            </div>
          </app-avatar>

          <div class="image-preview-overlay">
            @if (canReadMedia) {
              <div class="image-preview-actions">
                <button
                  mat-icon-button
                  matTooltip="Andere afbeelding kiezen"
                  [disabled]="submitted()"
                  (click)="handleOpenMediaPicker()"
                >
                  <mat-icon>swap_horiz</mat-icon>
                </button>

                <button
                  mat-icon-button
                  matTooltip="Afbeelding verwijderen"
                  [disabled]="submitted()"
                  (click)="handleClearMedia()"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>

        <span class="block text-xs text-gray-500 truncate">{{ media.label }}</span>
      } @else if (canReadMedia) {
        <button
          class="empty-state"
          [disabled]="submitted()"
          (click)="handleOpenMediaPicker()"
        >
          <mat-icon class="text-gray-400 !text-3xl !size-8">add_photo_alternate</mat-icon>
          <span class="text-sm text-gray-500">Kies een afbeelding</span>
        </button>
      }

      @if (!canReadMedia) {
        <span class="block text-xs text-gray-500">
          Om de afbeelding te kiezen heb je het recht "{{ mediaReadLabel }}" nodig.
        </span>
      }
    </div>

    <div class="space-y-2 flex flex-col">
      <label for="duration" class="flex font-medium text-sm select-none"
        >Duur

        <span class="ml-auto font-normal">{{ slider.value }}s</span>
      </label>

      <mat-slider
        [min]="sliderOptions.min"
        [max]="sliderOptions.max"
        [step]="sliderOptions.step"
        class="flex-auto [--mdc-slider-inactive-track-color:var(--color-gray-400)]"
      >
        <input matSliderThumb [formControl]="durationControl" id="duration" #slider />
      </mat-slider>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button mat-dialog-close [disabled]="submitted()">Annuleren</button>

  <button
    mat-button
    (click)="handleConfirm()"
    [disabled]="submitted() || !selectedMedia()"
  >
    <mat-spinner
      class="!absolute inset-0 m-auto pointer-events-none transition-opacity ease-in-out"
      [diameter]="16"
      [class.opacity-100]="loading()"
      [class.opacity-0]="!loading()"
    ></mat-spinner>

    <span [class.opacity-0]="loading()" class="transition-opacity">Opslaan</span>
  </button>
</mat-dialog-actions>
